// extracted by mini-css-extract-plugin
export default {"card":"nz0gZ"};